import angular = require('angular');
import { MeurhSolicitacoes } from '../../../Meurh/Solicitacoes/services/solicitacoes.service';
import { WorkflowService } from '../../../Workflow/workflow.service';
import { ISolicitacao } from '../../Solicitacoes/models/solicitacao.model';
import { ISolicitacaoAlteracaoVT } from '../models/solicitacaoalteracaovt.model';
import { MeurhSolicitacoesalteracoesvtsService } from '../solicitacoesalteracoesvts.service';
import { MeurhAcompanhamentoService } from '../../Acompanhamento/acompanhamento.service';
import { IAnexo } from '../../Anexos/models/anexo.model';
import { TiposDocumentosRequeridosService } from '../../../Tiposdocumentosrequeridos/tiposdocumentosrequeridos.service';
import { TipoSolicitacaoEnum } from '../../../../shared/enums/TipoSolicitacaoEnum';

export class MeurhSolicitacoesalteracoesvtsShowController implements ng.IController {
    static $inject = ['ModalConfirmService', '$scope', '$stateParams', '$state', 'MeurhSolicitacoesalteracoesvtsService', 'entity', 'NewToaster', 'WorkflowService', 'MeurhSolicitacoes', 'MeurhAcompanhamentoService', '$rootScope', 'TiposDocumentosRequeridosService', ];

    public action = 'retrieve';
    public busy: boolean = false;
    public path: number = this.$stateParams.path;
    public actionAnexo: string = 'show';
    public editanexo: boolean = false;
    public formAnexo: object = {};
    public entityAnexo: IAnexo = {
        casodeuso: 'ALTERACOESVTS'
    };
    public busyTipoDocumentos: boolean = true;
    public tiposdocumentosrequeridos: any = [];

    constructor(
        public ModalConfirmService: any,
        public $scope: angular.IScope,
        public $stateParams: angular.ui.IStateParamsService,
        public $state: angular.ui.IStateService,
        public entityService: MeurhSolicitacoesalteracoesvtsService,
        public entity: ISolicitacaoAlteracaoVT,
        public NewToaster: any,
        public WorkflowService: WorkflowService,
        public MeurhSolicitacoes: MeurhSolicitacoes,
        private MeurhAcompanhamentoService: MeurhAcompanhamentoService,
        public $rootScope: angular.IRootScopeService & { liberadoTela: (arg: string) => boolean },
        public TiposDocumentosRequeridosService: TiposDocumentosRequeridosService,
    ) {

        this.MeurhAcompanhamentoService.constructors.solicitacao = this.entity.solicitacao;
        this.MeurhAcompanhamentoService.reload();

        this.onDeleteSuccess();
        this.onDeleteError();
        this.afterReloadWorkflow();
    }

    $onInit(): void {
        this.WorkflowService.config(this.entity.solicitacao, 'meurh_solicitacoesalteracoesvts_');

        this.$scope.$on('meurh_tiposdocumentosrequeridos_list_finished', () => {
            this.busyTipoDocumentos = false;
            this.tiposdocumentosrequeridos = this.tiposdocumentosrequeridos.map((tipodocumentorequerido) => {
                tipodocumentorequerido.validateResult = false;
                tipodocumentorequerido.fileSelecionado = false;
                tipodocumentorequerido.file = '';
                return tipodocumentorequerido;
            });
        });
        this.documentosAnexos();
    }

    documentosAnexos(): void {
        const estabelecimento = this.entity.estabelecimento.estabelecimento;
        this.entityAnexo['solicitacao'] = this.entity.solicitacao;
        this.entityAnexo['estabelecimento'] = estabelecimento;
        if (this.$rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE')) {
            this.carregaTiposDocumentosRequeridos({
                empresa: this.entity.estabelecimento.empresa,
                estabelecimento
            });
        } else {
            this.carregaTiposDocumentosRequeridos();
        }
    }

    carregaTiposDocumentosRequeridos(params?: {
        empresa: string,
        estabelecimento: string
    }): void {
        this.busyTipoDocumentos = true;
        this.TiposDocumentosRequeridosService.entities = [];
        this.TiposDocumentosRequeridosService.loadParams = {
            to_load: 3,
            busy: false,
            finished: false
        };
        this.TiposDocumentosRequeridosService.after = {};
        this.TiposDocumentosRequeridosService.constructors = {
            tiposolicitacao: TipoSolicitacaoEnum.ALTERACAO_VT,
            ...params
        };
        this.tiposdocumentosrequeridos = this.TiposDocumentosRequeridosService.load();
    }

    afterReloadWorkflow(): void {
        this.$scope.$on('workflow_reloaded_after', (event: any, args: any) => {
            this.$state.reload();
        });
    }

    delete(force: boolean): void {
        this.entityService.delete(this.$stateParams['solicitacao'], force);
    }

    cancelar(entity: ISolicitacao): void {
        let confirm = this.ModalConfirmService.openCancelar(entity, 'solicitação de alteração de VT');

        confirm.result
            .then((entity: ISolicitacao): void => {
                this.busy = true;

                this.MeurhSolicitacoes.cancelar(entity)
                    .then((): void => {
                        this.NewToaster.pop({
                            type: 'success',
                            title: 'A solicitação de alteração de VT foi cancelada com sucesso.'
                        });

                        this.entityService.reload();
                        this.$state.go('meurh_solicitacoesalteracoesvts', this.entityService.constructors);
                    })
                    .catch((response: any): void => {
                        if (typeof (response.data.message) !== 'undefined' && response.data.message) {
                            this.NewToaster.pop({
                                type: 'error',
                                title: response.data.message
                            });
                        } else {
                            this.NewToaster.pop({
                                type: 'error',
                                title: 'Ocorreu um erro ao cancelar a solicitação.'
                            });
                        }
                    })
                    .finally((): void => {
                        this.busy = false;
                    });
            })
            .catch((error: any) => {
                if (error !== 'backdrop click' && error !== 'cancelar' && error !== 'escape key press') {
                    this.NewToaster.pop({
                        type: 'error',
                        title: error
                    });
                }
            });
    }

    onDeleteSuccess(): void {
        this.$scope.$on('meurh_solicitacoesalteracoesvts_deleted', (event: angular.IAngularEvent, args: any): void => {
            this.NewToaster.pop({
                type: 'success',
                title: 'Solicitação excluída com sucesso!'
            });

            this.$state.go('meurh_solicitacoesalteracoesvts', angular.extend(this.entityService.constructors));
        });
    }

    onDeleteError(): void {
        this.$scope.$on('meurh_solicitacoesalteracoesvts_delete_error', (event: angular.IAngularEvent, args: any): void => {
            if (typeof (args.response.data.message) !== 'undefined' && args.response.data.message) {
                this.NewToaster.pop({
                    type: 'error',
                    title: args.response.data.message
                });
            } else {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Ocorreu um erro ao excluir solicitação.'
                });
            }
        });
    }
}
